module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.ce2ef9b9.mp3";